import * as React from 'react';
import { connect } from 'react-redux';
import { StepWizardHost } from 'sos-common/js/components/WizardStepper/WizzardStepperHost';
import { FormWrapper } from 'sos-eservice-common/js/components/FormWrapper/FromWrapper';
import { MessageBanner } from 'sos-common/js/components/MessageBanner/messageBanner';
import { StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { setCurrentStep, closeMessageBar } from 'sos-eservice-common/js/Redux/Actions';
import { WizardHostStat } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { StepOne, StepTwo, StepThree, StepFour } from './steps';
export interface OmbudOrderFormProps {
  stepValidationMap: StepValidationMap;
  showSavedBanner: boolean;
  setCurrentStep: typeof setCurrentStep;
  closeMessageBar: typeof closeMessageBar;
}

export interface OmbudOrderFormState {
  activeStep: number;
}
/**
 * Defines the entire Ombudsansökan form. For steps; see [[StepOne]], [[StepTwo]], [[StepThree]]
 * This component is connected to a store.
 */
class OmbudOrderForm extends React.Component<OmbudOrderFormProps, OmbudOrderFormState> {
  constructor(props) {
    super(props);
    this.state = { activeStep: 1 };
  }

  public onCloseMessageBar = () => {
    this.props.closeMessageBar();
  };

  public handleStepChange = (stat: WizardHostStat) => {
    this.props.setCurrentStep(stat);
    this.setState({
      activeStep: stat.activeStep,
    });
  };
  public render() {
    return (
      <React.Fragment>
        {this.props.showSavedBanner && <MessageBanner onClose={this.onCloseMessageBar} />}
        <FormWrapper activeStep={this.state.activeStep} isOmbudForm={true} heading="Ombudsansökan">
          <StepWizardHost
            thankYouStep={4}
            onStepChange={this.handleStepChange}
            stepValidationMap={this.props.stepValidationMap}
            nextLabel="Nästa steg"
            previousLabel="Föregående"
            classNamesForFocusInput="step animated"
            hidePagination={true}>
            {}
            <StepOne />
            <StepTwo />
            <StepThree />
            <StepFour />
          </StepWizardHost>
        </FormWrapper>
      </React.Fragment>
    );
  }
}

const mapState2Props = (state: FormBaseStore<any>) => {
  return {
    stepValidationMap: state.validationState.stepValidationMap,
    showSavedBanner: state.globals.showSavedBanner,
  } as OmbudOrderFormProps;
};

const mapDispatch2Props = {
  closeMessageBar,
  setCurrentStep,
};

export default connect(mapState2Props, mapDispatch2Props)(OmbudOrderForm);
